export default {
  storage: localStorage,
  cacheKey: `@${process.env.REACT_APP_NAME}-token`,
};
